import type { V1PackMessageKey } from './v1-pack.en'

/** V1 packing lots list and delabel strings (Hindi), spread into hi.ts. The type forces every key in v1-pack.en.ts. */
export const v1PackHi: Record<V1PackMessageKey, string> = {
  // पैक हुए लॉट
  'pack.v1.lots.list.title': 'पैक हुए लॉट',
  'pack.v1.lots.list.see': 'सभी पैक लॉट देखें',
  'pack.v1.heldRuns.title': 'रुके रन जाँचें',
  'pack.v1.heldRuns.line': '{count} रन रुके हैं: जाँच कर बंद करें',
  'pack.v1.lots.list.seeLine': 'मंज़ूरी बाकी, मंज़ूर या रुके',
  'pack.v1.hallTile.title': 'पैकिंग हॉल',
  'pack.v1.hallTile.line': 'हॉल के पाउच, भेजना',
  'pack.v1.lots.list.none': 'इस हॉल में अभी कोई पैक लॉट नहीं',
  'pack.v1.lots.list.ready': '{n} {n:लॉट|लॉट} मंज़ूर: पाउच अभी हॉल में हैं',
  'pack.v1.lots.list.state.PACKING': 'पैकिंग चालू',
  'pack.v1.lots.list.state.WAITING': 'मंज़ूरी बाकी',
  'pack.v1.lots.list.state.RELEASED': 'मंज़ूर',
  'pack.v1.lots.list.state.HELD': 'रुका',
  'pack.v1.lots.list.state.RECALLED': 'वापस मँगाया',
  'pack.v1.lots.list.state.WITHDRAWN': 'बिक्री से हटा',
  'pack.v1.lots.list.dates': 'पैक {pkd} · {bb} से पहले',
  'pack.v1.lots.list.cartons': '{full} कार्टन ({per} वाले) + {partial}',
  'pack.v1.lots.list.waitingHint':
    'पाउच इंतज़ार वाली जगह पर रखें। ऑफ़िस की मंज़ूरी के बाद ही भेजें।',
  'pack.v1.lots.list.heldHint': 'रुका है: इसके कार्टन पर **रुका** बोर्ड लगाएँ। न भेजें।',
  'pack.v1.lots.list.recalledHint':
    'वापस मँगाया: **न हिलाएँ, न बेचें**। ऑफ़िस ख़रीदारों को फ़ोन कर रहा है।',
  'pack.v1.lots.list.reason': 'कारण: {reason}',
  'pack.v1.lots.list.reason.LAB_FAIL': 'लैब नतीजा फ़ेल',
  'pack.v1.lots.list.reason.RUN_MIXED': 'दूसरा बैच मिल गया',
  'pack.v1.lots.list.reason.LABEL_MISMATCH': 'लेबल जाँच बाकी',
  'pack.v1.lots.list.reason.QUALITY': 'क्वालिटी जाँच',
  // रुके पाउच खाली करें
  'pack.v1.delabel.title': 'रुके पाउच खाली करें',
  'pack.v1.delabel.row': 'पाउच खाली करें · लॉट …{tail}',
  'pack.v1.delabel.rowLine': '{count} पाउच · नई लाल धागे वाली बोरी में',
  'pack.v1.delabel.missing': 'यह काम इस फ़ोन पर नहीं है',
  'pack.v1.delabel.missingLine': 'वापस जाएँ, नेट के साथ फिर देखें।',
  'pack.v1.delabel.toEmpty': 'खाली या नष्ट करने के पाउच',
  'pack.v1.delabel.rule':
    'हमारा लेबल **दोबारा कभी नहीं** लगता। फ़िल्म गिनें और नष्ट करें। हर नई बोरी पर **लाल धागा**।',
  'pack.v1.delabel.job1': 'नई बोरी',
  'pack.v1.delabel.job1Line': 'हर बोरी पर टैग, फिर वज़न',
  'pack.v1.delabel.job1Done': '{count} बोरी · {kg} किलो',
  'pack.v1.delabel.job2': 'गिनती',
  'pack.v1.delabel.job2Line': 'खाली, नष्ट, फ़िल्म',
  'pack.v1.delabel.job2Done': '{emptied} खाली · {destroyed} नष्ट · {film} फ़िल्म',
  'pack.v1.delabel.tag.title': 'नई बोरी पर टैग',
  'pack.v1.delabel.tag.hint': 'लाल धागे वाली नई बोरी का टैग स्कैन करें',
  'pack.v1.delabel.tag.done': 'बोरियाँ हो गईं',
  'pack.v1.delabel.tag.wait': 'नई बोरी का टैग स्कैन करें',
  'pack.v1.delabel.weigh.title': 'बोरी तौलें',
  'pack.v1.delabel.weigh.label': 'बोरी {n} काँटे पर',
  'pack.v1.delabel.weigh.sackType': 'कौन सी बोरी?',
  'pack.v1.delabel.weigh.save': 'बोरी सेव करें',
  'pack.v1.delabel.weigh.wait': 'काँटे का वज़न लिखें',
  'pack.v1.delabel.saved': 'बोरी {n} सेव · {kg} किलो',
  'pack.v1.delabel.count.title': 'पाउच गिनें',
  'pack.v1.delabel.count.emptied': 'खाली किए पाउच',
  'pack.v1.delabel.count.destroyed': 'पूरे नष्ट किए पाउच',
  'pack.v1.delabel.count.film': 'नष्ट फ़िल्म',
  'pack.v1.delabel.count.filmHint': 'हर खाली पाउच की एक फ़िल्म',
  'pack.v1.delabel.count.gap': '{m} में से {n} पाउच गिने',
  'pack.v1.delabel.count.filmShort': 'फ़िल्म खाली पाउच से कम है',
  'pack.v1.delabel.count.done': 'गिनती हो गई',
  'pack.v1.delabel.count.wait': 'तीनों गिनती लिखें',
  'pack.v1.delabel.wait.sacks': 'पहले नई बोरियाँ तौलें',
  'pack.v1.delabel.wait.count': 'पाउच गिनें',
  'pack.v1.delabel.close.cta': 'खाली करना बंद करें',
  'pack.v1.delabel.close.title': 'खाली करना बंद करें?',
  'pack.v1.delabel.close.yes': 'हाँ, बंद करें',
  'pack.v1.delabel.close.sacks': '{count} · {kg} किलो',
  'pack.v1.delabel.close.locked': 'बंद के बाद गिनती **नहीं बदलेगी**।',
  'pack.v1.delabel.done.title': 'बंद हुआ',
  'pack.v1.delabel.done.line': 'लॉट …{tail} · {count} पाउच',
  'pack.v1.delabel.done.s1': 'ऑफ़िस निपटान दर्ज करेगा।',
  'pack.v1.delabel.closed': 'यह काम बंद है',
}
